import { axiosGet, axiosPost } from "../../../../react_axios/Axios";
import { insertUpdateStallPossessionChecklistUrl, getStallPossessionChecklistDetailsUrl, STALL_POSSESSION_CHECKLIST_DETAILS, INSERT_UPDATE_STALL_POSSESSION_CHECKLIST, headers } from "../../../../utils/constants";
import moment from "moment";

export const getStallPossessionChecklistDetails_action = (ExihibitionID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExihibitionID
        }

        const res = await axiosGet(getStallPossessionChecklistDetailsUrl, params, headers)

        dispatch({
            type: STALL_POSSESSION_CHECKLIST_DETAILS,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const insertUpdateStallPossessionChecklist_action = (ExihibitionID,StallPossessionChecklistList) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExihibitionID,
            StallPossessionChecklistList: StallPossessionChecklistList,
        }

        const res = await axiosPost(insertUpdateStallPossessionChecklistUrl, params, headers)

        dispatch({
            type: INSERT_UPDATE_STALL_POSSESSION_CHECKLIST,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}